import type { ComponentChildren, CSSProperties } from 'preact'

import { subtitleStyle, titleStyle } from '#src/assets/ui/shared/styles.ts'

type HeadingVariant = 'title' | 'subtitle' | 'section'

const variantStyles: Record<HeadingVariant, CSSProperties> = {
  title: titleStyle,
  subtitle: subtitleStyle,
  section: subtitleStyle,
}

export function Heading({
  level,
  variant,
  style,
  className,
  id,
  children,
}: {
  level: 1 | 2 | 3 | 4 | 5 | 6
  variant?: HeadingVariant
  style?: CSSProperties
  className?: string
  id?: string
  children: ComponentChildren
}) {
  const Tag = `h${level}` as const
  const baseStyle = variant ? variantStyles[variant] : { display: 'block' }

  return (
    <Tag id={id} className={className} style={{ ...baseStyle, ...style }}>
      {children}
    </Tag>
  )
}
